<template>
  <div class="sku-product">
    <!--商品图片-->
    <div class="summary-img" v-if="suite && suite.id && (suite.imageInfos || []).length">
      <img v-lazy="suite.imageInfos[0].bigPic" :key="suite.imageInfos[0].bigPic" @click="showPreview(0)" />
    </div>
    <template v-else>
      <div class="summary-img" v-if="skuInfo && (skuInfo.imageInfos || []).length">
        <img v-lazy="skuInfo.imageInfos[0].bigPic" :key="skuInfo.imageInfos[0].bigPic" @click="showPreview(0)" />
      </div>
    </template>

    <!--商品信息-->
    <div class="summary-content">
      <!--商品价格-->
      <p class="price" v-if="skuInfo && skuInfo.salePrice > 0">
        <span class="symbol">&yen;</span>
        <span class="number">{{ (totalPrice || skuInfo.salePrice) | formatNumber }}</span>
        <strong class="deposite-price" v-if="skuInfo.commodityDepositeVo">
          定金
          <span class="yen">&yen;</span>
          <span class="deposite">{{ skuInfo.commodityDepositeVo.depositAmount | formatNumber }}</span>
        </strong>
      </p>

      <!--已选信息-->
      <p class="selected">
        <span class="item">已选:</span>
        <span class="item">{{ currentSpecName }}</span>
        <span class="item" v-if="suite.name">{{ suite.name }}</span>
        <span class="item" v-for="item in service" v-if="item.name" :key="item.id">{{ item.name }}</span>
        <span class="item">{{ checkedInfo.number }}件</span>
      </p>

      <!--赠品-->
      <div class="gift" v-if="skuInfo && skuInfo.activity && (skuInfo.activity.gifts || []).length">
        <span class="label">赠品:</span>
        <ul class="gift-list">
          <li class="gift-item" v-for="(gift, index) in skuInfo.activity.gifts" :key="index">
            <img :src="gift.thumbnailPic" class="gift-img" />
            <span class="count">x1</span>
          </li>
        </ul>
      </div>
    </div>

    <!--大图展示-->
    <v-image-preview
      :show="isShowPreview"
      :images="previewImages"
      :startPosition="current"
      :onClose="onClosePreview"
      class="image-preview"
      v-backFn="{ show: isShowPreview, closeFn: 'onClosePreview' }"
    />
  </div>
</template>

<script>
import { app } from '@/utils'
import clientEnv from '@/utils/clientEnv'
export default {
  name: 'sku-product',
  props: {
    spuInfo: Object,
    skuInfo: Object,
    checkedInfo: Object,
    totalPrice: Number
  },
  data() {
    return {
      isShowPreview: false, // 是否开启大图模式
      current: 0 // 查看大图的索引
    }
  },
  computed: {
    service() {
      return this.checkedInfo.service || {}
    },
    suite() {
      return this.checkedInfo.currentSuite || {}
    },
    // 当前sku的规格名称组合，形如全网通版 8G+128G 极光幻境
    currentSpecName() {
      const specInfo = this.spuInfo.specItem
      const spec = specInfo.skuSpecList.find(item => {
        return item.skuId == this.skuInfo.id
      })

      if (spec) {
        return Object.keys(spec.sequences)
          .map(specId => {
            let specItemId = spec.sequences[specId]
            return specInfo.specItemSeq[specId][specItemId - 1].name
          })
          .join(' ')
      }
      return ''
    },
    // 轮播图片
    images() {
      return this.skuInfo && this.skuInfo.imageInfos
    },

    // 大图预览
    previewImages() {
      if (this.suite && this.suite.id && (this.suite.imageInfos || []).length) {
        return this.suite.imageInfos.map(v => v.hdPic)
      } else {
        return this.images.map(v => v.hdPic)
      }
    }
  },
  methods: {
    // 查看大图
    showPreview(index) {
      if (
        app.viewImgs({
          browse: {
            images: this.previewImages,
            imageIndex: index
          }
        })
      ) {
        // 查看大图
      } else {
        if (clientEnv.isVivoApp) {
          app.toggleTitleBar({
            isShow: false
          })
        }

        this.current = index
        this.isShowPreview = true
      }
    },
    // 关闭查看大图
    onClosePreview() {
      this.isShowPreview = false
    }
  }
}
</script>
